import React, { Component } from 'react'
import { MAIL_TEMPLATE_QUERY, UPDATE_MAIL_TEMPLATE_QUERY } from "../../queries/Queries"
import { IconButton } from '@mui/material';
import { FaLockOpen, FaLock, FaSortUp, FaSortDown } from "react-icons/fa";
import { useMutation, useQuery } from '@apollo/react-hooks';
import CircularProgressIndicator from '../elements/CircularProgressIndicator';
import { FaSave } from "react-icons/fa";
import { AUTH_TOKEN } from '../../constants';
import MailTemplate from './MailTemplate';
import { NavDropdown } from "react-bootstrap";
import { flattenStrapiData } from '../../utils/utilities';

class MailTemplateList extends Component {
  state = {
    locked: true,
    error: "",
    columns: [
        {column: "id",              direction: "asc"},
        {column: "template_type",     menu: "",                  menues: [ 
          "CheckinOpen",
          "CheckinAccepted",
          "CheckinApplied",
          "CheckinRejected",
          "CheckinDeleted",
          "CheckinRating",
          "AdInactive",
          "AdNotAffordAble",
          "RegisterUser",
          "ForgotPassword",
          "PasswordReset",
          "ExternAdsWithBookmarksExpired"
        ]},
        {column: "market_type",  menu: "",                  menues: [ 
          "Job",
          "RealEstate",
          "Vehicle",
        ]},
        {column: "subject",                            filter: ""},
        {column: "body",                           filter: ""},
        {column: "html body"},
        {column: "updatedAt",      direction: "asc"},
    ],
    sortBy: "id:asc",
    filters: {
    }
  }

  onChangeFilter(e, index) {
      let columns = this.state.columns;
      for(let i = 0; i < columns.length; i++) {
          if(columns[i].filter !== undefined)
            columns[i].filter = ""
      }
      columns[index].filter = e.target.value
      // console.log("filter: " + columns[index].filter)
      this.setState({columns: columns,})
  }
  
  onSubmitFilter(e, index) {
    e.preventDefault();
    let columns = this.state.columns;
    // console.log("columns " + columns[index].column + " filter: "+ columns[index].filter) 
    // columns[index].filter = e.target.value
    let filters = { 
      [columns[index].column]: {containsi: columns[index].filter}
    }
    // console.log("on submit filters:" + filters)
    this.setState({filters: filters,})
  }

  onSelectFilter(e, index, value) {
    e.preventDefault();
    let columns = this.state.columns;
    let filters = {}
    columns[index].menu = value
    if(columns[index].menu !== undefined && columns[index].menu.length > 0) {
      filters[columns[index].column] = {
        "eq": columns[index].menu
      }
    }
    this.setState({filters: filters, columns: columns})
  }

  handleLockChange(e) {
    this.setState({locked: !this.state.locked});
  }

  updateColumn(at) {
    let column = this.state.columns[at]
    if(column.direction === undefined)
        return;

    column.direction = column.direction === 'asc' ? 'desc' : 'asc';
    let columns = this.state.columns;
    for(let i = 0; i < columns.length; i++) {
        if(columns[i].direction === undefined)
            continue;
        if(i === at)
            columns[at] = column
        else
            columns[i].direction = 'asc'
    }
    let sortBy =  column.column + ":" + column.direction
    this.setState({columns: columns, sortBy: sortBy})
  }

  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    if(!token) {
      return(
        <div>
          <span className="Error">You must be loged in first</span>
        </div>
      )
    }

    return (
        <div>
          <IconButton onClick={this.handleLockChange.bind(this)} >{this.state.locked ? <FaLock/> : <FaLockOpen/> }</IconButton>
          <br/>
          <div><span className="error">{this.state.error}</span></div>
          <GetList
            token={token} 
            locked={this.state.locked}
            updateColumn={this.updateColumn.bind(this)}
            onChangeFilter={this.onChangeFilter.bind(this)}
            onSubmitFilter={this.onSubmitFilter.bind(this)}
            onSelectFilter={this.onSelectFilter.bind(this)}
            columns={this.state.columns}
            sortBy={this.state.sortBy}
            filters={this.state.filters}
          />
      </div>
    )
  }
}

function GetList({locked, token, updateColumn, onChangeFilter, onSubmitFilter, columns, sortBy, filters, onSelectFilter}) {
  const {data, loading, error, refetch} = useQuery(MAIL_TEMPLATE_QUERY, {variables: {sortBy: sortBy, filters: filters}})
  if(error) return(<span className="error">{error.message}</span>)
  
  function sort(columnNumber) {
    updateColumn(columnNumber)
    refetch({variables: {sortBy: sortBy, filters: filters}})
  }

  function getArrow(direction) {
    return direction === "asc" ? <FaSortUp/> : <FaSortDown/>
  }
 
  function filter(e, index) {
    onChangeFilter(e, index)
  }

  function getColumnHeader(index) {
    var column = columns[index]
    const makeBodyWide = column.column === "body" && !locked
    const makeWide = column.column === "html body" || makeBodyWide
    return <th 
      style={makeWide ? {
        width: "20vw"
      } : {}}
    >
      <div>
       <h4>{columns[index].column}</h4>{columns[index].filter !== undefined ? <form onSubmit={(e) => onSubmitFilter(e, index)}><input  value={columns[index].filter}  onChange={(e) => filter(e, index)} /></form> : ""} 
       <p>{columns[index].menu !== undefined ? columns[index].menu.length > 0 ? columns[index].menu : "Every" : ""}</p>
       {columns[index].menues !== undefined ? 
        
        <NavDropdown title={`${columns[index].column}s`} id="collasible-nav-dropdown">
          {columns[index].menues.map((menu, i) => <NavDropdown.Item key={i} onClick={(e) => onSelectFilter(e, index, menu)} >{menu}</NavDropdown.Item>).concat(
            <NavDropdown.Item key={columns[index].menues.length} onClick={(e) => onSelectFilter(e, index)} >Every</NavDropdown.Item>
          )}
        </NavDropdown>
          // <form onSubmit={(e) => onSubmitFilter(e, index)}><input  value={columns[index].filter}  onChange={(e) => filter(e, index)} /></form> 
       : ""} 
       <div onClick={columns[index].direction !== undefined ? () => sort(index) : () => {}}>{columns[index].direction !== undefined ? getArrow(columns[index].direction) : ""}</div>
      </div></th>;
  }

  let mailTemplates = data?.mailTemplates?.data
  return (
    <div>{
      loading ? <CircularProgressIndicator size={60} /> : <table className="table table-bordered">
        <thead>
          <tr>
            {getColumnHeader(0)}
            {getColumnHeader(1)}
            {getColumnHeader(2)}
            {getColumnHeader(3)}
            {getColumnHeader(4)}
            {getColumnHeader(5)}
            {getColumnHeader(6)}
            {token && !locked && <th><h4>Edit</h4></th>}
            {/* {token && !locked && <th><h4>Delete</h4></th>} */}
          </tr>
        </thead>
          
          <tbody>
          {mailTemplates !== undefined ? mailTemplates.map(mailTemplate => {
            mailTemplate = flattenStrapiData(mailTemplate)
            return <MailTemplate 
            key={mailTemplate.id} 
            locked={locked} 
            mail_template={mailTemplate}>
              <Update refetch={() => refetch()}/>
              {/* <Delete refetch={() => refetch()}/> */}
            </MailTemplate>
          }) : ""}
        </tbody>
      </table> }
    </div>
  )
}

function Update({id, state, refetch}) {
  const [updateMailTemplate, {loading, error}] = useMutation(UPDATE_MAIL_TEMPLATE_QUERY)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) {
  console.log("ERROR:"+error)
  alert("Update Mutation Error: "+ error.message)
}
  return (
      <IconButton onClick={e => { 
      updateMailTemplate({variables: {id: id, body: state.body, subject: state.subject}})
      .then(data => {
        refetch()
      })
      .catch(e => alert("Execute Update Mutation Error: "+e))
    }
    }><FaSave/></IconButton>
  )
}


export default MailTemplateList